import { render, staticRenderFns } from "./VisitorPhoneInput.vue?vue&type=template&id=5b5184b6"
import script from "./VisitorPhoneInput.vue?vue&type=script&lang=js"
export * from "./VisitorPhoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports